
















































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import EmailTemplate from '@/pages/Pages/Templates/EmailTemplate.vue'
import EmailPreviewDialog from '@/components/Email/EmailPreviewDialog.vue';
import { MsgTransports } from '@/store/types';
import { SelectWings } from "wings-ui-components";

@Component({components: {GenericDistribution, EmailTemplate, EmailPreviewDialog, SelectWings}})
export default class EmailDistribution extends GenericDistribution {

  transport = MsgTransports.EMAIL

  isShowEmail = false
  emailContent = null

  showEmail() {
    this.emailContent = this.template.message
    this.isShowEmail = true
  }

  get attachedFiles() {
    return this.template?.attachedFiles?.length > 0 ? this.template.attachedFiles.map((item: any) => `${item.name} (${item.fileData.length*(3 / 4) - 2})`) : []
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
